import AssemblyRules from "./Assembly";

export default AssemblyRules